import { render } from "./PopupImage.vue?vue&type=template&id=f18634d8&scoped=true"
import script from "./PopupImage.vue?vue&type=script&lang=js"
export * from "./PopupImage.vue?vue&type=script&lang=js"

import "./PopupImage.vue?vue&type=style&index=0&id=f18634d8&scoped=true&lang=scss"
import "./PopupImage.vue?vue&type=style&index=1&id=f18634d8&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18634d8"]])

export default __exports__